<div class="provider-details">
  <div class="modules">
    <section class="detail-tabs-header" data-test="tabs-header">
      @for (module of moduleNames; track module) {
        <button
          [ngClass]="{'selected-section' : module === lastSelectedSection}"
          class="detail-section-link"
          (click)="scrollToSection(module)"
          [attr.data-test]="'section-link-' + module"
        >
          {{ module }}
        </button>
      }
    </section>
  
    @if (showBioSection()) {
      <section
        id="about-section"
        class="about info-module"
        data-test="about-section"
      >
        <a id="about-link" [href]="currentRoute + '#about'">
          <h3>Meet {{ providerShareableProfile().display_first_name }}</h3>
        </a>

        @if (providerShareableProfile().mini_bio?.length) {
          <div class="mini-bio-container" data-test="about-mini-bio-card">
            <iris-icon
              name="quote"
              colorToken="$color-dec-indigo-80"
              [size]="iconSizes.SM"
            />
            <div class="mini-bio">
              {{ providerShareableProfile().mini_bio }} <span class="name-signoff"> - {{ providerShareableProfile().display_first_name }} </span>
            </div>
          </div>
        }

        <p data-test="provider-bio">{{ providerBio }}</p>

        @if (showTestimonial) {
          <div class="clients-are-saying" data-test="clients-are-saying">
            <div class="icon-header">
              <iris-icon
                name="quote"
                [size]="iconSizes.SM"
                colorToken="$color-dec-indigo-80"
              />
              <h3>Clients are saying...</h3>
            </div>
            <div class="testimonial">
              <span class="testimonial-feedback">{{ latestTestimonialFeedback }}</span>
              <span class="testimonial-source">{{ latestTestimonialSource }}</span>
            </div>
          </div>
        }
      </section>
    }

    @if (showSpecialtiesSection()) {
      <section 
        class="specialties info-module"
        id="specialties-section"
        data-test="specialties-section"
      >
        <section data-test="specialties">
          <a id="specialties-link" [href]="currentRoute + '#specialties'" class="section-header">
            <span class="icon-wrapper">
              <iris-icon
                name="star_shine"
                [size]="iconSizes.MD"
                colorToken="$color-action-base"
              />
            </span>
            <h3>{{ headerNames.SPECIALIZES_IN }}</h3>
          </a>
          @if (topSpecialties().length > 0) {
            <div class="top-specialties-pills-container">
              <h4>Top specialties</h4>
              <div
                class="top-specialties-pills" 
                data-test="top-specialties-pills"
              >
                @for (speciality of topSpecialties(); track speciality.id) {
                  <pill
                    icon="check_alt"
                    [displayText]="speciality.name"
                    iconColorToken="$color-brand-1-base"
                    textColorToken="$color-brand-1-base"
                    backgroundColorToken="$color-dec-blue-10"
                    [hideIcon]="!speciality.isQueryParam"
                  />
                }
              </div>
            </div>  
          }

            <div class="parallel-list-container">
            @if (allOtherSortedSpecialties.length) {
              <div class="single-column-list">
                <h4>
                  General expertise in
                </h4>
                <ul data-test="specialties-section-list">
                  @for (specialty of allOtherSortedSpecialties; track specialty.name) {
                    <li class="specialty-list-item" [class.highlight]="specialty.isQueryParam">
                      @if (specialty.isQueryParam) {
                        <iris-icon
                          name="check_alt"
                          [size]="iconSizes.SM"
                          colorToken="$color-action-base"
                        />
                      }
                      {{ specialty.name }}
                    </li>
                  }
                </ul>
              </div>
            }
            @if (treatmentApproaches.length) {
              <div class="single-column-list">
                <h4>Treatment approaches</h4>
                <ul>
                  @for (approach of treatmentApproaches; track approach) {
                    <li>{{ approach }}</li>
                  }
                </ul>
              </div>
            }
          </div>
        </section>
      </section>
    }

    @if (showWorksWithSection()) {
      <hr />
      <section
        class="info-module"
        id="works-with-section"
        data-test="works-with-section"
      >
        <a id="works-with-link" [href]="currentRoute + '#workswith'" class="section-header">
          <span class="icon-wrapper">
            <iris-icon
              name="person_heart"
              [size]="iconSizes.MD"
              colorToken="$color-action-base"
            />
          </span>
          <h3> 
            {{ moduleNames[moduleNames.length - 2] }}
          </h3>
        </a>
        <div class="parallel-list-container">
          @if(providerShareableProfile().services_offered?.length > 0) {
            <div class="single-column-list">
              <h4>Types of services</h4>
              <ul>
                @for (serviceOffered of providerShareableProfile().services_offered; track serviceOffered.id) {
                  <li>{{ serviceOffered?.name }}</li>
                }
              </ul>
            </div>
          }
          @if (agesSupported.length > 0) {
            <div class="single-column-list">
              <h4>Ages</h4>
              <ul>
                @for (age of agesSupported; track age) {
                  <li>{{ age }}</li>
                }
              </ul>
            </div>
          }

        @if (communitiesSupported().length > 0) {
          <div class="single-column-list">
            <h4>Communities supported</h4>
            <ul>
              @for (community of communitiesSupported(); track community) {
                <li>{{ community }}</li>
              }
            </ul>
          </div>
        }

        @if(providerShareableProfile().languages?.length > 0) {
          <div class="single-column-list">
            <h4>Languages</h4>
            <ul>
              @for (language of providerShareableProfile().languages; track language.id) {
                <li>{{ language?.name }}</li>
              }
            </ul>
          </div>
        }
        </div>
      </section>
    }

    @if (showInsuranceLicensuresSection()) {
      <hr />
      <section
        id="insurance-and-licensure-section"
        class="info-module insurance-and-licensure"
        data-test="insurance-and-licensure-section"
      >
        <div class="insurance-container">
          <a id="insurance-and-licensure-link" [href]="currentRoute + '#insurance-and-licensure'" class="section-header">
            <div class="icon-wrapper">
              <iris-icon
                name="shield_with_heart"
                [size]="iconSizes.MD"
                colorToken="$color-action-base"
              />
            </div>
            <h3>{{ moduleNames[moduleNames.length - 1] }}</h3>
          </a>

          @if (providerNetworkCompaniesGroupedByInsuranceName.length > 0) {
            <h4>Insurance accepted</h4>
            @for (insuranceGroup of providerNetworkCompaniesGroupedByInsuranceName; track insuranceGroup[0].insurance_id) {
              <div
                class="insurance-list"
                data-test="insurances-section-list"
              >
                <span class="insurance-group-name"> {{ insuranceGroup[0].insurance_name }} </span>
                <ul>
                  @for (pnc of insuranceGroup; track pnc.id) {
                    <li>
                      {{ pnc.name }}
                    </li>
                  }
                </ul>
              </div>
            }
          }
        </div>

        @if (licensures.length > 0) {
          <div class="licensure-container">
            <h4>Licensure</h4>
            <ul data-test="licensure-section-list">
              @for (licensure of licensures; track licensure) {
                <li>{{ licensure }}</li>
              }
            </ul>
          </div>
        }

        @if (stateLicenses.length > 0) {
          <div class="state-license-container">
            <h4>Licensed in</h4>
            <ul data-test="licensed-in-list">
              @for (stateLicense of stateLicenses; track stateLicense) {
                <li>
                  {{ stateLicense }}
                </li>
              }
            </ul>
          </div>
        }
      </section>
    }
  </div>
</div>